import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const PrivateRoute = () => {
    const isAuthenticated = localStorage.getItem('isAdminAuthenticated') === 'true';
    // Если пользователь аутентифицирован, показываем дочерний компонент (Outlet),
    // в противном случае перенаправляем на страницу входа.
    return isAuthenticated ? <Outlet /> : <Navigate to="/admin" replace />;
};

export default PrivateRoute;
